/**
 * Spec Phase 4 Slice 4D — SectionBreadcrumb.
 *
 * Shape per brief §4 / handoff design tokens:
 *   "07. Detailed description of drawings · EP § R.42(1)(e)"
 */
import React from 'react';
import type { SpecSectionRow } from '@/api/client';

interface Props {
  section: SpecSectionRow | null;
}

export default function SectionBreadcrumb({ section }: Props): JSX.Element | null {
  if (!section) return null;
  const seq = String(section.sequence_num).padStart(2, '0');
  return (
    <div
      className="flex items-center gap-2 px-6 py-3 border-b border-zinc-200 bg-white"
      data-testid="spec-section-breadcrumb"
    >
      <span className="font-mono text-xs text-zinc-500">{seq}.</span>
      <span className="text-sm font-medium text-zinc-900">
        {/* BUG-048 — drafter-renamed heading wins over the
            seeded title when present. */}
        {(section.custom_title && section.custom_title.trim())
          || section.title}
      </span>
      {section.statute_ref && (
        <>
          <span className="text-xs text-zinc-400">·</span>
          <span className="font-mono text-[11px] text-zinc-500">
            {section.statute_ref}
          </span>
        </>
      )}
      {section.is_auto_generated && (
        <span className="ml-2 inline-flex items-center rounded-sm bg-zinc-100 px-1.5 py-0.5 font-mono text-[10px] text-zinc-600">
          auto-generated
        </span>
      )}
      {section.is_frozen && (
        <span className="ml-2 inline-flex items-center rounded-sm bg-emerald-50 px-1.5 py-0.5 font-mono text-[10px] text-emerald-700">
          frozen
        </span>
      )}
    </div>
  );
}
